import React, { FC } from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Token } from '@app/types/token';
import { ModalTitle } from '@app/screens/nft-marketplace/MakeOfferDialog/components/ModalTitle';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { BuyItNowWithBidsAuction } from '@app/screens/nft-marketplace/MakeOfferDialog/components/BuyItNowWithBidsAuction';
import { EnglishAuction } from '@app/screens/nft-marketplace/MakeOfferDialog/components/EnglishAuction';
import { DutchAuction } from '@app/screens/nft-marketplace/MakeOfferDialog/components/DutchAuction';
import { BlindAuction } from '@app/screens/nft-marketplace/MakeOfferDialog/components/BlindAuction';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  token0: Token;
  token1: Token;
  sellCurrency: Token | undefined;
  listing: NFTMarketplaceListing;
  tokenId: string;
  lpTokenId: string;
  poolAddress: string;
}

export const MakeOfferDialog: FC<Props> = ({
  isOpen,
  onClose,
  token0,
  token1,
  sellCurrency,
  listing,
  tokenId,
  lpTokenId,
  poolAddress
}) => {
  if (!sellCurrency) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      motionPreset="slideInBottom"
      size="xs"
    >
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: ['100vw', '586px'], padding: '24px' }}>
        <ModalTitle
          tokenId={listing.tokenId}
          token1Symbol={token1?.symbol}
          token0Symbol={token0?.symbol}
        />

        {listing.type === 'BUY_IT_NOW_WITH_BIDS' && (
          <BuyItNowWithBidsAuction
            listing={listing}
            sellCurrency={sellCurrency}
            onClose={onClose}
            tokenId={tokenId}
            lpTokenId={lpTokenId}
            poolAddress={poolAddress}
          />
        )}
        {listing.type === 'ENGLISH_AUCTION' && (
          <EnglishAuction
            listing={listing}
            sellCurrency={sellCurrency}
            onClose={onClose}
            tokenId={tokenId}
            lpTokenId={lpTokenId}
            poolAddress={poolAddress}
          />
        )}
        {listing.type === 'DUTCH_AUCTION' && (
          <DutchAuction
            listing={listing}
            sellCurrency={sellCurrency}
            onClose={onClose}
            tokenId={tokenId}
            lpTokenId={lpTokenId}
            poolAddress={poolAddress}
          />
        )}
        {listing.type === 'BLIND' && (
          <BlindAuction
            listing={listing}
            sellCurrency={sellCurrency}
            onClose={onClose}
            tokenId={tokenId}
            lpTokenId={lpTokenId}
            poolAddress={poolAddress}
          />
        )}
      </ModalContent>
    </Modal>
  );
};
